import React, { useEffect, useState } from "react";
import VisitorInsights from "../visitor-insights";
import supabase from "../supabase";

const Stats = ({ lists }) => {
  const [refresh, setRefresh] = useState(0);
  const [visits, setVisits] = useState(null);
  const [visitError, setVisitError] = useState(false);
  const [shares, setShares] = useState(null);
  const [shareError, setShareError] = useState(false);
  // RPCs expose aggregate totals only; raw visitor/event records stay restricted.
  // Separate errors allow one section to work before both migrations are applied.
  useEffect(() => {
    let active = true;
    setShareError(false);
    setShares(null);
    setVisits(null);
    setVisitError(false);
    supabase.rpc("app_visit_totals").then(({ data, error }) => {
      if (!active) return;
      if (error) setVisitError(true); else setVisits(data);
    }).catch(() => { if (active) setVisitError(true); });
    supabase.rpc("app_share_totals").then(({ data, error }) => {
      if (!active) return;
      if (error) setShareError(true);
      else setShares(data);
    }).catch(() => { if (active) setShareError(true); });
    return () => { active = false; };
  }, [refresh]);
  useEffect(() => {
    document.title = "Stats - Pray With Me";
    return () => { document.title = "Pray With Me"; };
  }, []);
  // Feed metrics describe the supplied (maximum 1,000) posts, not an all-time SQL count.
  const praises = lists.filter(post => post.requestType === "Praise Report").length;
  const metric = (label, value) => <div className="stats-metric" key={label}><dt>{label}</dt><dd>{Number(value).toLocaleString()}</dd></div>;
  return (
    <section className="stats-panel">
      <header className="stats-heading"><span className="stats-eyebrow">COMMUNITY OVERVIEW</span><h1>Stats</h1><p>Prayer, praise, and the reach of our community.</p></header>
      <section className="stats-section" aria-labelledby="visits-heading">
        <div className="stats-section-title"><h2 id="visits-heading">All-time overview</h2><button className="stats-refresh" onClick={() => setRefresh(value => value + 1)}>Refresh</button></div>
        {visitError ? <p className="stats-status">Visit tracking isn’t available yet. Apply the visits migration to enable it.</p> : visits ? <dl className="stats-metrics stats-visit-metrics">{metric("Visits", visits.visits)}{metric("Unique visitors", visits.visitors)}</dl> : <p className="stats-status">Loading visits…</p>}
        <p className="stats-note">Since tracking began. A new visit starts after 30 minutes of inactivity. Unique visitors estimates browsers; stats visits are excluded.</p>
      </section>
      <VisitorInsights />
      <section className="stats-section" aria-labelledby="sharing-heading">
        <div className="stats-section-title"><h2 id="sharing-heading">App sharing · All time</h2><button className="stats-refresh" onClick={() => setRefresh(value => value + 1)}>Refresh</button></div>
        {shareError ? <p className="stats-status" role="status">Sharing stats aren’t available yet. Please try again later.</p> : shares ? <dl className="stats-metrics">
          {metric("Share actions", shares.total)}
          {metric("Native shares", shares.native_share)}
          {metric("Links copied", shares.copy_link)}
        </dl> : <p className="stats-status" role="status">Loading sharing stats…</p>}
        <p className="stats-note">Actions since tracking began, not unique people or confirmed deliveries. Links copied counts copies made directly by our app; copies inside the device’s share menu are included under native shares.</p>
      </section>
      <section className="stats-section" aria-labelledby="feed-heading">
        <h2 id="feed-heading">Prayer feed</h2>
        <dl className="stats-metrics">
          {metric("Total posts", lists.length)}
          {metric("Prayer requests", lists.length - praises)}
          {metric("Praise reports", praises)}
        </dl>
        <p className="stats-note">Based on the latest {lists.length.toLocaleString()} loaded posts · Up to 1,000 posts.</p>
      </section>
    </section>
  );
};

export default Stats;
